<form class="lead_form" [formGroup]="leadForm" (submit)="submitLead($event)">
  <div class="lead_form_header">
    <img src="assets/icons/dialogue-icon.svg" alt="dialogo ícone">
    <h3 >Entrar em contato</h3>
  </div>
  
  <div class="lead_form_body" *ngIf="!formSubmited">
    <app-input-text
      [label]="'Nome'"
      [fieldName]="'nome'"
      [control]="leadForm.get('name')"
      [placeholder]="'Digite seu nome'"
      [maxlength]="101"
      (blured)="onNameInputFieldBlur()"
      (inputed)="filterLetters()">
    </app-input-text>

    <div class="mail_phone">

      <app-input-text
        class="input_email"
        [label]="'E-mail'"
        [fieldName]="'e-mail'"
        [control]="leadForm.get('email')"
        [placeholder]="'Digite seu e-mail'"
        [maxlength]="50">
      </app-input-text>

      <app-input-text
        [label]="'Telefone'"
        [fieldName]="'telefone'"
        [control]="leadForm.get('telefone')"
        [placeholder]="'(xx) xxxxx-xxxx'"
        (keyupped)="onPhoneChanged($event)"
        [mask]="phoneMask">
      </app-input-text>

    </div>

    <app-dropdown-select
      [options]="channels"
      [fieldName]="'forma de contato'"
      [control]="leadForm.get('channel')"
      [showErrors]="true"
      [placeholder]="selectDisplayValue"
      (selectedOption)="changeSubject($event)">
    </app-dropdown-select>

  </div>

  <div class="success-form" *ngIf="formSubmited">
    <div class="box-success">
      <img src="/assets/icons/success-icon.svg" alt="icone de sucesso">
    </div>
    <div class="success-title">Solicitação enviada!</div>
    <div class="success-txt">{{ descriptionSuccess }}</div>
  </div>

  <button *ngIf="!formSubmited"
    class="btn-base btn-lopes"
    [disabled]="leadForm.invalid"
    [ngClass]="{'spinner spinner-white': loading}">
    Enviar
  </button>

  <div class="error-form" *ngIf="errorForm">
    <div class="box-error">
      Ocorreu um erro. Tente novamente mais tarde.
    </div>
  </div>

</form>
